import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const ContactUs = () => {
  return (
    <>
    <div className="bg-gray-100 py-12">
      <div className="max-w-7xl mx-auto mt-6  px-6 lg:px-20"> 
        
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Contact Us</h1>
        <p className="text-gray-600 mb-8">
          Fill out our form and we will contact you within 24 hours.
        </p>

        {/* Main Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Section: Contact Details */}
          <div className="bg-white p-6 rounded-md shadow-md">
            {/* Call Us */}
            <div className="flex items-center mb-6">
              <FaPhoneAlt className="text-orange-500 text-xl mr-4" />
              <div>
                <h3 className="text-lg font-bold text-gray-800">Call To Us</h3>
                <p className="text-gray-600">We are open Monday to Saturday (10:00 - 18:00)</p>
                <p className="text-gray-800 font-medium">Phone: +91 81415 14454</p>
              </div>
            </div>

            {/* Write To Us */}
            <div className="flex items-center">
              <FaEnvelope className="text-orange-500 text-xl mr-4" />
              <div>
                <h3 className="text-lg font-bold text-gray-800">Write To Us</h3>
                <p className="text-gray-600">Email: kkrca@gmail.com</p>
              </div>
            </div>
          </div>

          {/* Right Section: Contact Form */}
          <div className="bg-white p-6 rounded-md shadow-md">
            <form>
              {/* Name, Email, Phone Fields */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                {/* Name Field */}
                <input
                  type="text"
                  placeholder="Your Name *"
                  className="w-full px-4 py-[0.6rem] border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500"
                  required
                />
                {/* Email Field */}
                <input
                  type="email"
                  placeholder="Your Email *"
                  className="w-full px-4 py-[0.6rem] border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500"
                  required
                />
                {/* Phone Field */}
                <input
                  type="tel"
                  placeholder="Your Phone *"
                  className="w-full px-4 py-[0.6rem] border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500"
                  required
                />
              </div>

              {/* Message Field */}
              <textarea
                placeholder="Your Message"
                rows={4}
                className="w-full px-4 py-[0.6rem] border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 mb-4"
              ></textarea>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-orange-500 text-white py-[0.6rem] rounded-md hover:bg-orange-600 transition duration-200"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ContactUs;
